//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import { FormInput } from '@/components/Form'
import { rutFilter } from 'vue-dni'
import ROLES from '@/constants/roles'
import Button from '~/components/Shared/Button'
import ModalWithTitleBar from '~/components/Shared/ModalWithTitleBar'

export default {
  name: 'InvitationModal',
  components: {
    FormInput,
    ValidationObserver,
    ModalWithTitleBar,
    Button,
  },
  props: {
    onSuccess: {
      default: () => {},
      type: Function,
    },
    roleType: {
      type: String,
      default: ROLES.EMPLOYEE,
    },
    value: {
      type: Boolean,
      default: true,
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    const [{ roles }] = await Promise.all([
      this.$strapi.$http.$get('/users-permissions/roles'),
    ])
    this.role = roles.find((role) => role.type === this.roleType).id
    this.roles = roles
    this.$store.commit('loading', false)
  },
  data() {
    return {
      ROLES,
      roles: [],
      selectedCompany: null,
      radioRole: ROLES.UNEMPLOYED,
      options: {
        languages: [],
        locations: [],
        situationLaboral: [
          {
            value: 'Empleado',
            label: 'Empleado',
          },
        ],
      },
      form: {
        situationLaboral: '',
        occupation: '',
        user: {
          names: '',
          lastnames: '',
          email: '',
          repeatEmail: '',
          identification_number: '',
        },
        message: null,
      },
      active: this.value,
      validateEmailModal: false,
    }
  },
  computed: {
    formSubmit() {
      const form = {
        ...this.form.user,
        identification_number: this.form.user.identification_number,
      }
      delete form.repeatEmail
      if (form.email) {
        return form
      }
      delete form.email
      return form
    },
  },

  watch: {
    value() {
      this.active = this.value
    },
    form: {
      handler(val) {
        this.form.user.identification_number = rutFilter(
          this.form.user.identification_number
        )
      },
      deep: true,
    },
  },
  methods: {
    close() {
      this.active = !this.active
      this.form = {
        situationLaboral: '',
        occupation: '',
        user: {
          names: '',
          lastnames: '',
          email: '',
          repeatEmail: '',
          identification_number: '',
        },
        message: null,
      }
      this.$emit('close')
      this.$emit('input', this.active)
    },
    importMassiveUsers() {
      this.close()
      this.$emit('import-massive-users')
    },
    submit() {
      if (this.form.user.email === '' && this.form.user.repeatEmail === '') {
        this.validateEmailModal = !this.validateEmailModal
      } else {
        this.saveUser()
      }
    },
    async saveUser() {
      this.$store.commit('loading', true)
      try {
        await this.$repository.invitation.newSingleCreateUsers({
          user: this.formSubmit,
        })
        this.onSuccess()
        if (this.form.user.email !== '' && this.form.user.repeatEmail !== '') {
          this.$emit('user-with-email')
        }
        if (this.form.user.email === '' && this.form.user.repeatEmail === '') {
          this.$emit('user-without-email')
        }
      } catch (e) {
        this.$buefy.notification.open({
          message: e.message,
          type: 'is-danger',
          duration: 5000,
        })
      } finally {
        this.$store.commit('loading', false)
        this.validateEmailModal = false
        this.close()
      }
    },
    toggleValidateWithoutEmailModal() {
      this.validateEmailModal = !this.validateEmailModal
    },
  },
}
